module.exports = {"530902001":"凤翔街道","530902002":"忙畔街道","530902102":"博尚镇","530902202":"南美拉祜族乡","530902203":"蚂蚁堆乡","530902204":"章驮乡","530902206":"圈内乡","530902207":"马台乡","530902208":"邦东乡","530902209":"平村彝族傣族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530902.json
// module id = 2606
// module chunks = 0